import axios, { AxiosResponse } from 'axios';
import { useConfig } from '../../config';
import { useEffect, useRef } from 'react';
import { Res, useApi } from '../../state/api';
import { Loader } from '../Loader/Loader';
import { ApiCart, DeliveryTypeCompany } from '../../types';

declare global {
	interface Window {
		_klarnaCheckout?: (api: unknown) => void;
	}
}
type Props = {
	cart: ApiCart;
	deliveryType: DeliveryTypeCompany;
};

export const KlarnaCheckout = ({ cart, deliveryType }: Props) => {
	const { data } = useApi(Res.klarnaCheckout, {});
	const { api: apiUri } = useConfig();
	const container = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (data && container.current) {
			renderSnippet(container.current, data);
			updateKcoOrder(apiUri, deliveryType);
		}
	}, [data]); // eslint-disable-line react-hooks/exhaustive-deps

	// calculate a string uniquely identifying the current cart
	// used in deciding when to update the KlarnaCheckout widget
	const cartHash = `${cart.totals?.total};${deliveryType};${cart.items.map((e) => `${e.product.id}:${e.quantity}`).join()}`;

	useEffect(() => {
		updateKcoOrder(apiUri, deliveryType);
	}, [cartHash]);

	if (!data) return <Loader />;
	return <div ref={container} />;
};

function updateKcoOrder(apiUri: string, deliveryType?: string) {
	if (window._klarnaCheckout) {
		window._klarnaCheckout(
			async (api: { suspend: () => void; resume: (updateResponse: AxiosResponse<any, any>) => void }) => {
				api.suspend();
				try {
					const bodyFormData = new FormData();
					bodyFormData.append('customerType', 'private');
					bodyFormData.append('shippingType', deliveryType ?? 'servicepoint');
					bodyFormData.append('orderComment', '');
					bodyFormData.append('discountCode', '');

					axios({
						method: 'post',
						url: apiUri + 'checkout/kco/update',
						data: bodyFormData,
						headers: {
							'Content-Type': 'application/x-www-form-urlencoded',
						},
						withCredentials: true,
					}).then(function (response) {
						api.resume(response);
					});
				} catch (e) {
					Promise.reject(e);
				}
			}
		);
	}
}

export function renderSnippet(checkoutContainer: HTMLDivElement, htmlSnippet: string) {
	// https://docs.klarna.com/klarna-checkout/get-started/render-checkout-snippet/
	checkoutContainer.innerHTML = htmlSnippet;
	var scriptsTags = checkoutContainer.getElementsByTagName('script');
	// This is necessary otherwise the scripts tags are not going to be evaluated
	for (var i = 0; i < scriptsTags.length; i++) {
		var parentNode = scriptsTags[i].parentNode;
		var newScriptTag = document.createElement('script');
		newScriptTag.type = 'text/javascript';
		newScriptTag.text = scriptsTags[i].text;
		parentNode?.removeChild(scriptsTags[i]);
		parentNode?.appendChild(newScriptTag);
	}
}
